/**
 * Runtime configuration injected by /runtime-config.js (Docker entrypoint or public/ for dev).
 * Falls back to CRA build-time process.env when a key is not set at runtime.
 */

export function getRuntimeConfig() {
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }
  return {};
}

export function getRuntimeEnv(key, fallback = "") {
  const runtime = getRuntimeConfig();
  const runtimeValue = runtime[key];
  if (runtimeValue !== undefined && runtimeValue !== null && String(runtimeValue).trim() !== "") {
    return String(runtimeValue).trim();
  }
  const buildValue = process.env[key];
  if (buildValue !== undefined && buildValue !== null && String(buildValue).trim() !== "") {
    return String(buildValue).trim();
  }
  return fallback;
}
